import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=737f2b7e&scoped=true&"
import script from "./forget-pwd.vue?vue&type=script&lang=ts&"
export * from "./forget-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=737f2b7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737f2b7e",
  null
  
)

export default component.exports